//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import EntityPicker from 'src/components/Pickers/Picker';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  props: ['canChangeCategory'],
  components: {
    TeDialog: TeDialog,
    EntityPicker: EntityPicker
  },
  data: function data() {
    return {
      expenseData: {
        expense_category_id: null,
        is_locked: null,
        billable_status: null
      }
    };
  }
};